import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  PERMISSION_REQUEST_NOT_FOUND: 'Permission request was not found.',
  PERMISSION_TYPE_NOT_AVAILABLE: 'This permission type is not available.',
  PERMISSION_NOT_ELIGIBLE:
    'You are not eligible for this permission request.',
  PERMISSION_LIMIT_EXCEEDED:
    'The monthly permission limit has been used.',
  PERMISSION_DURATION_EXCEEDED:
    'The requested permission duration is outside the allowed range.',
  PERMISSION_CONFIGURATION_MISSING:
    'Permission configuration is not configured.',
  PERMISSION_DATE_OVERLAP:
    'The selected period overlaps another request.',
  PERMISSION_ATTENDANCE_CONFLICT:
    'The selected period conflicts with attendance.',
  PERMISSION_REQUEST_NOT_CANCELLABLE:
    'This permission request can no longer be canceled.',
  WORKFLOW_NOT_CONFIGURED: 'The approval workflow is not configured.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  VALIDATION_ERROR: 'Check the entered permission information.',
  INVALID_DATE_RANGE: 'The selected date range is invalid.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
  EMPLOYEE_PROFILE_REQUIRED:
    'An employee profile is required for permission requests.',
};

const DETAILED_CODES = new Set([
  'PERMISSION_LIMIT_EXCEEDED',
  'PERMISSION_DURATION_EXCEEDED',
  'PERMISSION_CONFIGURATION_MISSING',
  'BUSINESS_RULE_ERROR',
]);

function errorCode(error: unknown, apiCode: string | undefined): string | undefined {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    return (error as { code: string }).code;
  }
  return apiCode;
}

export function timePermissionErrorMessage(
  error: unknown,
  fallback = 'Unable to load permission requests.',
): string {
  const apiError = normalizeApiError(error);
  const code = errorCode(error, apiError.code);
  if (code && DETAILED_CODES.has(code) && apiError.message?.trim()) {
    return apiError.message.trim();
  }
  if (code && MESSAGES[code]) return MESSAGES[code];
  if (apiError.message?.trim()) {
    return apiError.message.trim();
  }
  return fallback;
}
